import * as React from 'react';
import * as classnames from 'classnames';
import { classes } from '../../../utils/Classes';
import { splitCamelCase } from '../../../utils/splitCamelCase';
import { SelectedCategoryTheme, UnselectedCategoryTheme } from '../../../../theme/default-theme';
import { Button } from 'elc-buttons';
import { FilterSet } from '../../../domain/entities/FilterSet';
import { observer } from 'mobx-react';
import { translate } from 'elc-service';
import styled from 'styled-components';
import { Row, Column } from 'elc-grid';
import { ContentSpacing } from 'elc-base-theme';
import { CategoryFiltersButton } from './CategoryFiltersItem';
import { Filter } from '../../../domain/entities/Filter';
import { ActiveFiltersNo } from './ActiveFiltersNo';

export interface IFiltersSet {
    handleFilterSetToggle(filterSet: FilterSet): void;
    filterSets: FilterSet[];
    showFiltersWhenToggled?: boolean;
    checkboxFilters?: boolean;
    alwaysOn?: boolean;
    translations?: {
        filterByLabel: string;
    };
}

const StyledCategory = styled(Button)`
    cursor: pointer;
    text-transform: capitalize;
    ${(props: { isCategoryTagSelected: boolean }) =>
        props.isCategoryTagSelected ? SelectedCategoryTheme : UnselectedCategoryTheme};
`;

const StyledCol = styled(Column)`
    padding-top: ${ContentSpacing.space8};
`;

const StyledRow = styled(Row)`
    padding-top: ${ContentSpacing.space20};
`;

const StyledButtonRow = styled(Row)`
    padding-top: ${ContentSpacing.space40};
`;

@translate(['filterByLabel'])
@observer
export class FiltersSets extends React.Component<IFiltersSet> {
    private computeStyledCategoryClassName(filterCategory: string, active: boolean) {
        return classnames('elc-styled-filters-category-tab', 'js-elc-styled-filters-category-tab', {
            active
        });
    }

    private getSelectedFilterSet(filterSet: FilterSet) {
        if (!this.props.filterSets || !this.props.filterSets.length) {
            return null;
        }

        const styledButtonRowClassnames = classes('styled-filters-button-row');

        return (
            <StyledButtonRow className={styledButtonRowClassnames}>
                {filterSet.filters.map((option: Filter, keyNumber: number) => {
                    return (
                        <CategoryFiltersButton
                            onSelectFilterClick={option.toggleActiveState}
                            key={`${option.key}-${keyNumber}`}
                            isSelected={option.active}
                            label={option.label}
                            checkboxFilter={this.props.checkboxFilters}
                        />
                    );
                })}
            </StyledButtonRow>
        );
    }

    private getFilters(filterSet: FilterSet) {
        if (this.shouldHideFiltersForSet(filterSet)) {
            return null;
        }

        return this.getSelectedFilterSet(filterSet);
    }

    private shouldHideFiltersForSet(filterSet: FilterSet) {
        return !this.props.alwaysOn && (!this.props.showFiltersWhenToggled || !filterSet.isOpen);
    }

    render() {
        const styledCategoryRowClassnames = classes('styled-filters-category-row');
        const { filterSets, handleFilterSetToggle } = this.props;

        if (!filterSets) {
            return null;
        }

        return (
            <StyledRow className={styledCategoryRowClassnames}>
                <StyledCol xs={12} sm={12} md={12} lg={12}>
                    {filterSets
                        ? filterSets.map((filterSet: FilterSet) => {
                              return (
                                  <div
                                      key={filterSet.key}
                                      className="elc-styled-filters-category-tab-wrapper"
                                  >
                                      <StyledCategory
                                          onClick={() => handleFilterSetToggle(filterSet)}
                                          key={`${filterSet.key}`}
                                          isCategoryTagSelected={filterSet.isOpen}
                                          aria-label={filterSet.label}
                                          className={this.computeStyledCategoryClassName(
                                              filterSet.key,
                                              filterSet.isOpen
                                          )}
                                      >
                                          {this.props.translations?.filterByLabel}{' '}
                                          {splitCamelCase(filterSet.label)}{' '}
                                          <ActiveFiltersNo
                                              filtersNo={filterSet.activeFilters.length}
                                          />
                                      </StyledCategory>
                                      {this.getFilters(filterSet)}
                                  </div>
                              );
                          })
                        : null}
                </StyledCol>
                {this.props.children}
            </StyledRow>
        );
    }
}
